module.exports = __webpack_public_path__ + "img/a9_05.22a5cce8.jpg";